module.exports = __webpack_public_path__ + "static/media/biomec.af6b8d17.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/acaro_blanco_papa/curativa/biomec.png
// module id = 1987
// module chunks = 3